import { SoundManager } from '../common/audio/soundManager';
import { PauseDialog } from '../common/pauseDialog';
import { UIDialog } from '../common/ui/uiDialog';
import { UIPanel } from '../common/ui/uiPanel';
import { UIPanelButton } from '../common/ui/uiPanelButton';
import { UIText } from '../common/ui/uiText';
import { Game } from './game';
import { GameStyle } from './gameStyle';

export class GameOptionsDialog extends UIDialog {
  toggleSoundButton: UIPanelButton;
  toggleAutoPlayButton: UIPanelButton;

  public build() {
    let popup = new UIPanel({
      size: {x: 260, y: 320},
      anchor: {x: 0.5, y: 0.45},
      pivot: {x: 0.5, y: 0.5},
      position: {x: 0, y: 0},
      radius: this.options.panel.radius,
      color: this.options.panel.color,
      gradient: this.options.panel.gradient,
      borderColor: this.options.panel.borderColor,
      borderWidth: this.options.panel.borderWidth,
      shadow: this.options.panel.shadow,
      parent: this
    });

    let titleText = new UIText({
      text: 'OPTIONS',
      position: {x: 0, y: 15},
      anchor: {x: 0.5, y: 0},
      pivot: {x: 0.5, y: 0},
      horizontalAlign: 'center',
      color: this.options.title.color,
      fontFamily: this.options.title.fontFamily,
      fontSize: this.options.title.fontSize,
      fontWeight: this.options.title.fontWeight,
      shadow: this.options.title.shadow,
      parent: popup
    });

    let flipLayoutButton = new UIPanelButton({
      text : 'Flip Layout',
      anchor : {x : 0.5, y : 0},
      pivot : {x : 0.5, y : 0},
      position : {x : 0, y : 70},
      size : {x : 160, y : 40},
      callback : () => {
        Game.instance.solitaire.toggleFlipLayout();
      },
      panelColors: this.options.button.panelColors,
      textColors: this.options.button.textColors,
      radius: this.options.button.radius,
      fontFamily: this.options.button.fontFamily,
      fontSize: this.options.button.fontSize,
      textOffset: this.options.button.textOffset,
      borderColor: this.options.button.borderColor,
      borderWidth: this.options.button.borderWidth,
      parent : popup
    });

    this.toggleSoundButton = new UIPanelButton({
      text : 'Enable Sound',
      anchor : {x : 0.5, y : 0},
      pivot : {x : 0.5, y : 0},
      position : {x : 0, y : 130},
      size : {x : 160, y : 40},
      callback : () => {
        Game.instance.solitaire.toggleSfxOn();
        this.updateButtonText();
      },
      panelColors: this.options.button.panelColors,
      textColors: this.options.button.textColors,
      radius: this.options.button.radius,
      fontFamily: this.options.button.fontFamily,
      fontSize: this.options.button.fontSize,
      textOffset: this.options.button.textOffset,
      borderColor: this.options.button.borderColor,
      borderWidth: this.options.button.borderWidth,
      parent : popup
    });

    this.toggleAutoPlayButton = new UIPanelButton({
      text : 'Enable AutoPlay',
      anchor : {x : 0.5, y : 0},
      pivot : {x : 0.5, y : 0},
      position : {x : 0, y : 190},
      size : {x : 160, y : 40},
      callback : () => {
        Game.instance.solitaire.toggleAutoplay();
        this.updateButtonText();
      },
      panelColors: this.options.button.panelColors,
      textColors: this.options.button.textColors,
      radius: this.options.button.radius,
      fontFamily: this.options.button.fontFamily,
      fontSize: this.options.button.fontSize,
      textOffset: this.options.button.textOffset,
      borderColor: this.options.button.borderColor,
      borderWidth: this.options.button.borderWidth,
      parent : popup
    });

    let backButton = new UIPanelButton({
      text : 'Back',
      anchor : {x : 0.5, y : 0},
      pivot : {x : 0.5, y : 0},
      position : {x : 0, y : 250},
      size : {x : 160, y : 40},
      callback : () => {
        this.hide();
        this.callback('back');
      },
      panelColors: this.options.button.panelColors,
      textColors: this.options.button.textColors,
      radius: this.options.button.radius,
      fontFamily: this.options.button.fontFamily,
      fontSize: this.options.button.fontSize,
      textOffset: this.options.button.textOffset,
      borderColor: this.options.button.borderColor,
      borderWidth: this.options.button.borderWidth,
      parent : popup
    });
  }

  public onWake() {
    this.updateButtonText();
  }

  protected updateButtonText() {
    if(Game.instance.solitaire.useAutoPlay)
      this.toggleAutoPlayButton.text = 'Disable Auto Play';
    else
      this.toggleAutoPlayButton.text = 'Enable Auto Play';

    if(SoundManager.instance.sfxOn) 
      this.toggleSoundButton.text = 'Disable Sound';
    else
      this.toggleSoundButton.text = 'Enable Sound';
  }
}